import axios from "axios";
import Vue from "vue";
import colors from "vuetify/lib/util/colors";
import Vuetify from '../../plugins/vuetify'

export default {
    state: {
        user: null,
        language: null,
        alerts: [],
        tourMode: false,
        showOverlay: false,
        step: 0,
        steps: [
            {title: "Dashboard", code: "dashboard", text: "Esta é a página onde tem acesso rápido a todas as funcionalidades do Naltio. Está dividida em 4 secções: Iniciar, Biblioteca, Personalizar e Administração."},
            {title: "Consulta Exemplo", code: "dashboard-new-appointment", text: "Para ficar mais familiarizado com o Naltio procederemos ao agendamento de uma consulta exemplo."},
            //{title: "Agendamento", code: "dashboard-schedule", text: "..."},
            //{title: "Pacientes", code: "dashboard-patients", text: "..."},
            //{title: "Monitorização", code: "dashboard-monitoring", text: "..."},
            {title: "Nova Consulta", text: "Aqui terá de preencher os dados necessários para o agendamento da consulta.", event: 'tour-go-to-new-appointment', code: 'appointment-form'},
            //{title: "Novo Agendamento", text: "No campo Paciente, pode criar um novo ou selecionar um existente. Preencha os campos pretendidos.", event: 'tour-open-appointment'},
            {title: "Consulta", text: "Após o preenchimento, poderá iniciar diretamente a consulta ou agendar para o calendário.", code: 'appointment-form', component: "patient-field", event: 'tour-fill-appointment'},
            {title: "Agendamento", text: "Como pode observar, a consulta foi agendada e aparece no seu calendário. Para aceder a toda a informação da consulta, basta clicar nesta.", event: 'tour-create-appointment'},
            {title: "Iniciar Consulta", text: "Só após a chegada do paciente é que deve iniciar a consulta.", event: 'tour-open-appointment', code: 'appointment-form'},
            //{title: "Agendamento", text: "No Agendamento poderá criar e gerir as suas consultas e de todos os profissionais de saúde. Poderá ainda integrar o Agendamento com o Google Calendar. Crie uma consulta com um clique na data e hora pretendida.", event: 'tour-go-to-appointment'},
            //{title: "Histórico Clínico", text: "Na consulta, poderá analizar o histórico clínico do paciente, com a apresentação da anamnese, testes, diagnóstico e tratamentos, através dos filtros.", event: 'tour-go-to-appointment'},
            {title: "Anamnese", text: "Mediante as queixas do paciente, poderá registar as notas necessárias assim como as classificações internacionais das doenças (CIDs) correspondentes.", event: 'tour-go-to-appointment'},
            //{title: "Anamnese", text: "...", event: 'tour-anamnesis'},
            {title: "Queixa Principal", text: "Utilizando a barra de pesquisa, poderá selecionar o código CID correspondente à queixa do paciente.", event: 'tour-anamnesis-main-complaint'},
            {title: "Medicamentos", text: "Caso o paciente esteja a tomar alguma medicação, poderá registá-la aqui. Aqui poderá adicionar qualquer medicamento disponível no mercado, aprovado pelo INFARMED.", event: 'tour-anamnesis-drugs'},
            {title: "Medicamentos", text: "Pode ainda importar medicamentos adicionados de consultas anteriores.", event: 'tour-anamnesis-add-drug'},
            {title: "Testes", text: "Aqui poderá realizar os testes disponibilizados para cada módulo, que lhe permitirá obter um diagnóstico correto.", event: 'tour-tests'},
            {title: "Teste de Sinais vitais", text: "Um dos testes disponíveis é o teste de sinais vitais.", event: 'tour-test-vital-signs'},
            {title: "Teste de Sinais vitais", text: "Um dos testes disponíveis é o teste de sinais vitais.", event: 'tour-test-vital-signs-submit'},
            {title: "Testes de Medicina Tradicional Chinesa", text: "Dentro da Medicina Tradicional Chinesa terá acesso a vários testes: Estrutura Corporal, Língua, Palpação Abdominal, Pulso e Ryodoraku.", event: 'tour-test-tongue', module: "mtc"},
            {title: "Teste da Língua", text: "Neste exemplo iremos realizar o teste da língua.", event: 'tour-test-tongue-open', module: "mtc"},
            {title: "Teste da Língua", text: "Neste passo poderá selecionar as opções que melhor se enquadram mediante o seu paciente.", event: 'tour-test-tongue-open-templates', module: "mtc"},
            {title: "Teste da Língua", text: "Depois de preenchidos os parâmetros terá de finalizar o teste.", event: 'tour-test-tongue-select-template', module: "mtc"},
            {title: "Teste da Língua", text: "Após a criação do teste poderá facilmente visualizar o seu conteúdo.", event: 'tour-test-tongue-submit', module: "mtc"},
            {title: "Teste de Osteopatia", text: "Relativamente a Osteopatia, tem ao seu dispor um teste de avaliação funcional.", event: 'tour-test-osteo', module: "osteo"},
            {title: "Teste de Osteopatia", text: "Aqui poderá selecionar os vários membros sujeitos à avaliação.", event: 'tour-test-osteo-open', module: "osteo"},
            {title: "Teste de Osteopatia", text: "Para cada membro poderá realizar os testes correspondentes.", event: 'tour-test-osteo-select', module: "osteo"},
            {title: "Teste de Osteopatia", text: "Após a criação do teste poderá facilmente visualizar o seu conteúdo, clicando no icon do olho.", event: 'tour-test-osteo-submit', module: "osteo"},
            {title: "Diagnóstico", text: "Depois de recolhida toda a informação necessária durante a avaliação, poderá neste passo registar o diagnóstico.", event: 'tour-diagnosis'},
            {title: "Tratamentos", text: "Nesta secção tem acesso a todos os tratamentos que pode realizar e onde pode registar a metodologia utilizada.", event: 'tour-treatments'},
            // {options: true, tcm: {title: "Matéria Médica Chinesa", text: "...", event: 'tour-treatments-mmc'},
            //                 fito: {title: "Suplementos", text: "...", event: 'tour-treatments-supplements'},
            //                 other: {title: "Nutrição", text: "...", event: 'tour-treatments-nutrition'}},
            // {options: true, tcm: {title: "Adicionar Matéria Médica Chinesa", text: "...", event: 'tour-treatments-mmc-add'},
            //                 fito: {title: "Adicionar Suplemento", text: "...", event: 'tour-treatments-supplements-add'},
            //                 other: {title: "Adicionar Nutrição", text: "...", event: 'tour-treatments-nutrition-add'}},
            {title: "Acupuntura", text: "Dentro da Acupuntura pode registar os pontos utilizados durante o tratamento. Tem também acesso a um conjunto de recomendações de pontos a utilizar mediante o diagnóstico obtido.", event: 'tour-acu-open', module: "mtc"},
            {title: "Acupuntura", text: "Depois de selecionar os pontos poderá facilmente visualizar a sua posição recorrendo à matriz apresentada.", event: 'tour-acu-select', module: "mtc"},
            //{title: "Interação Medicamentosa", text: "...", event: 'tour-treatments-mmc-interaction'},
            //{title: "Prescrição", text: "A prescrição para além de impressa, poderá ser enviada via email para o paciente.", event: 'tour-prescription'},
            //{title: "Imprimir Prescrição", text: "Selecionada a opção, edite o tamanho e selecione o(s) tratamento(s) a enviar.", event: 'tour-prescription-print-options'},
            //{title: "Imprimir Prescrição", text: "...", event: 'tour-prescription-print'},
            {title: "Pacientes", text: "Depois de terminada a consulta, para aceder às informações registadas, basta aceder à barra lateral esquerda onde se encontra a opção 'Pacientes'", code: 'patients'},
            {title: "Pacientes", text: "Aqui terá acesso aos registos de todos os pacientes.", event: 'tour-go-to-patients'},
            //{title: "Selecionar Paciente", text: "..."},
            {title: "Paciente", text: "Após selecionar o paciente em questão, terá acesso aos seus dados pessoais.", event: 'tour-select-patient', code: "clinic_history"},
            //{title: "Paciente", text: "..."},
            {title: "Histórico Clínico", text: "Após selecionar o Histórico Clínico, tem acesso à lista de consultas do paciente, onde pode facilmente visualizar todas as informações recolhidas durante a consulta, sejam elas relativas à Anamnese, Testes, Diagnóstico e Tratamentos.", event: "tour-select-clinic-history"},
            //{title: "Histórico Clínico - Filtros", text: "...", event: "tour-open-clinic-history-filters"},
            {title: "Histórico Clínico - Testes", text: "Após selecionar o Histórico Clínico, tem acesso à lista de consultas do paciente, onde pode facilmente visualizar todas as informações recolhidas durante a consulta, sejam elas relativas à Anamnese, Testes, Diagnóstico e Tratamentos.", event: "tour-select-clinic-history-tests"},
            {title: "Histórico Clínico - Diagnóstico", text: "Após selecionar o Histórico Clínico, tem acesso à lista de consultas do paciente, onde pode facilmente visualizar todas as informações recolhidas durante a consulta, sejam elas relativas à Anamnese, Testes, Diagnóstico e Tratamentos.", event: "tour-select-clinic-history-diagnosis"},
            {title: "Histórico Clínico - Tratamentos", text: "Após selecionar o Histórico Clínico, tem acesso à lista de consultas do paciente, onde pode facilmente visualizar todas as informações recolhidas durante a consulta, sejam elas relativas à Anamnese, Testes, Diagnóstico e Tratamentos.", event: "tour-select-clinic-history-treatments"},
            {title: "Fim", text: "Bom trabalho! A equipa Naltio", event: 'end'},
        ]
    },
    getters: {
        tourMode: (state) => {
            return state.tourMode;
        },
        tourTitle: (state, getters) => {
            if(state.steps[state.step].options) {
                if(getters.hasModule('mtc')) return state.steps[state.step].tcm.title;
                if(getters.hasModule('fito')) return state.steps[state.step].fito.title;
                return state.steps[state.step].other.title;
            }
            return state.steps[state.step].title;
        },
        tourText: (state, getters) => {
            if(state.steps[state.step].options) {
                if(getters.hasModule('mtc')) return state.steps[state.step].tcm.text;
                if(getters.hasModule('fito')) return state.steps[state.step].fito.text;
                return state.steps[state.step].other.text;
            }
            return state.steps[state.step].text;
        },
        tourStep: (state) => {
            //return state.step;
            if(!state.tourMode) return false;
            else return state.steps[state.step].code;
        },
        tourStepEvent: (state, getters) => {
            if(state.steps[state.step].options) {
                if(getters.hasModule('mtc')) return state.steps[state.step].tcm.event;
                if(getters.hasModule('fito')) return state.steps[state.step].fito.event;
                return state.steps[state.step].other.event;
            }
            return state.steps[state.step].event;
        },
        existUser: (state) => {
            if (state.user) return true;
            else return false;
        },
        googleLogged: (state) => {
            return state.user.space.google_logged;
        },
        userId: (state) => {
            return state.user.id
        },
        userLanguage: () => {
            return Vue.config.language
        },
        userName: (state) => {
            return state.user.name
        },
        userEmail: (state) => {
            return state.user.email
        },
        userColor: (state) => {
            return state.user.color
        },
        userPlatformColor: (state) => {
            return state.user.platform_color
        },
        userMonitoringEmailBody: (state) => {
            if(state.user.monitoring_email_body) return state.user.monitoring_email_body
            else {
                return (
                    "Para começar a fazer registos dos seus sinais e sintomas, p.f. click no link abaixo. Depois siga os seguintes passos:  \r\n\r\n" +
                    "1. Clicar em “Novo Registo”\r\n" +
                    "2. Ajustar o dia e hora se necessário (nota: se o valor que vai introduzir corresponder ao dia e hora que já aparecem, não necessita alterar nada).\r\n" +
                    "3. Clicar no número de bolas (de 1 a 10) em função da intensidade sentida: sendo 1 - valor mínimo e 10 - valor máximo\r\n" +
                    "4. Clicar em “Criar”\r\n\r\n" +
                    "Deve repetir estes passos para cada sinal/sintoma incluídos.\r\n\r\n" +
                    "Por favor, faça um registo pelo menos 1 vez por dia, sendo possível e desejável fazer mais do que uma vez por dia.\r\n\r\n" +
                    "Clicar neste link para começar: " +
                    "[link]\r\n\r\n" +
                    "Atentamente,\r\n" +
                    "[name]"
                );
            }
        },
        spaceId: (state) => {
            return state.user.space.id
        },
        spaceName: (state) => {
            return state.user.space.space_name
        },
        spaceLogo: (state) => {
            return state.user.space.logo_url
        },
        spaceSubscriptionPlan: (state) => {
            return state.user.space.subscription_plan;
        },
        spaceNotifySMS: (state) => {
            return state.user.space.notify_sms;
        },
        spaceNotifyEmail: (state) => {
            return state.user.space.notify_email;
        },
        calendarMin: (state) => {
            return state.user.calendar_min
        },
        calendarMax: (state) => {
            return state.user.calendar_max
        },
        showSaturday: (state) => {
            return state.user.show_saturday
        },
        showSunday: (state) => {
            return state.user.show_sunday
        },
        appDurationInterval: (state) => {
            if(state.user.space.app_duration_interval) return state.user.space.app_duration_interval;
            else return 15;
        },
        autoDrugImport: (state) => {
            return state.user.space.auto_drug_import;
        },
        hasAnyModule: (_, getters) => {
            return getters.hasPlan;
            //if(!state.user.space.subscription_plan) return false;
            //if(state.user.modules.length > 0) return true;
            //else if(Object.keys(state.user.space.modules).length > 0) return true;
            //else return false;
        },
        hasPlan: (state) => {
            if(!state.user.space.subscription_plan) return false;
            if(state.user.space.subscription_plan.days_left > 0) return true;
            return false;
        },
        hasPlanExpiring: (state) => {
            if(!state.user.space.subscription_plan) return false;
            if(state.user.space.subscription_plan.days_left > 0 && state.user.space.subscription_plan.days_left <= 3) return true;
            return false;
        },
        getPlanExpirationDays: (state) => {
            return state.user.space.subscription_plan.days_left;
        },
        hasModule: (state) => (module) => {
            if (state.user.modules.includes(module)) return true;
            else return false
        },
        hasRole: (state) => (role) => {
            if (state.user.role === 'admin') {
                if(role == 'manager') {
                    if(state.user.id != 23) return false;
                }
                return true;
            }
            else if (state.user.role === 'manager' && role != 'admin') return true;
            else if (state.user.role === role) return true;
            else return false;
        },
        timers: (state) => {
            return state.user.timers
        },
        timersComplete: (state) => {
            var timers_complete = 0;
            state.user.timers.forEach(t => {
                if (t.user_id == state.user.id && !t.active && !t.notification_seen) timers_complete += 1;
            })
            return timers_complete
        },
        alerts: (state) => {
            return state.alerts
        },
        firstTime: (state) => {
            if(!state.user.space.subscription_plan && state.user.modules.length == 0) return true;
            else return false;
        },
        hasSpeciality: (state) => {
            return state.user.specialities.length > 0;
        },
        spaceModules: (state) => {
            return state.user.space.modules;
        },
        establishments: (state) => {
            return state.user.space.establishments.sort((a, b) => {return a.id - b.id});
        },
        hasPerm: (state) => {
            if(state.user.id == 6 || state.user.id == 24 || state.user.id == 19 || state.user.id == 63) return true;
			return false;
        },
        canCreatePatient: (state, getters) => {
            if(getters.hasRole('receptionist')) return true;
            else {
                if(state.user.patients_permission) return true;
                else return false;
            }
        },
        canCreateAppointment: (state, getters) => {
            if(getters.hasRole('receptionist')) return true;
            else {
                if(state.user.appointment_permission) return true;
                else return false;
            }
        },
        canAccessFullCalendar: (state, getters) => {
            if(getters.hasRole('receptionist')) return true;
            else {
                if(state.user.calendar_permission) return true;
                else return false;
            }
        },
        pricing: (state) => {
            return state.user.space.pricing;
        },
        isAdmin: (_, getters) => {
            return getters.hasRole('admin');
        },
        isSuperAdmin: (state, getters) => {
            return getters.hasRole('admin') && state.user.id == 23;
        },
        isMarketing: (state, getters) => {
            return getters.isAdmin && state.user.id == 222;
        },
        isStaff: (_, getters) => {
            return getters.isAdmin && !getters.isMarketing;
        },
        isExternalEntity: (state) => {
            return state.user.space.external_entity != null;
        },
        externalEntity: (state) => {
            return state.user.space.external_entity;
        }
    },
    mutations: {
        SET_TOUR_MODE(state, value) {
            state.tourMode = value;
            if(!value) state.step = 0;
        },
        INCREMENT_TOUR_STEP(state, getters) {
            state.step += 1;
            let module = state.steps[state.step].module;
            while(module && !getters.hasModule(module)) {
                state.step += 1;
                module = state.steps[state.step].module;
            }
        },
        SET_USER(state, user) {
            state.user = user
            if (user.language) {
                Vue.config.language = user.language
            }
            const words = user.platform_color.split("-");
            let colorName;
            if (words[1]) colorName = words[0] + words[1].charAt(0).toUpperCase() + words[1].slice(1);
            else colorName = user.platform_color;
            Vuetify.framework.theme.themes.light.primary = colors[colorName];
            Vuetify.framework.theme.themes.light.secondary = colors[colorName].lighten5;
            Vuetify.framework.theme.themes.light.alert = colors[colorName].lighten2;
        },
        REMOVE_USER(state) {
            state.user = null
        },
        SET_LANGUAGE(state, lang) {
            state.language = lang
            Vue.config.language = lang
        },
        SET_TIMERS(state, timers) {
            state.user.timers = timers
        },
        ADD_TIMER_COMPLETE(state) {
            state.timersComplete++;
        },
        SET_ALERTS(state, alerts) {
            state.alerts = alerts
        },
        REMOVE_ALERTS(state) {
            state.alerts = []
        },
        SET_MODULES(state, modules) {
            state.user.modules = modules
        },
        SET_SUBSCRIPTION_PLAN(state, plan) {
            state.user.space.subscription_plan = plan
        },
        SET_GOOGLE_LOGGED(state, value) {
            state.user.space.google_logged = value;
        },
        ADD_ESTABLISHMENT(state, establishment) {
            state.user.space.establishments.push(establishment);
        },
        EDIT_ESTABLISHMENT(state, establishment) {
            //for(let i = 0; i < state.user.space.establishments.length; i++) {
            //    if(state.user.space.establishments[i].id == establishment.id) state.user.space.establishments[i] = establishment;
            //}
            let index = state.user.space.establishments.findIndex(e => e.id == establishment.id);
            state.user.space.establishments[index] = establishment;
        },
        DELETE_ESTABLISHMENT(state, id) {
            let index = state.user.space.establishments.findIndex(e => e.id == id);
            state.user.space.establishments.splice(index, 1);
        },
        ADD_ESTABLISHMENT_OFFICE(state, {establishment, office}) {
            let index = state.user.space.establishments.findIndex(e => e.id == establishment.id);
            state.user.space.establishments[index].offices.push(office);
        },
        REMOVE_ESTABLISHMENT_OFFICE(state, {establishment, office}) {
            let establishment_index = state.user.space.establishments.findIndex(e => e.id == establishment.id);
            let office_index = state.user.space.establishments[establishment_index].offices.findIndex(o => o.id == office.id);
            state.user.space.establishments[establishment_index].offices.splice(office_index, 1);
        },
        REMOVE_ESTABLISHMENT_LOGO(state, establishment) {
            let index = state.user.space.establishments.findIndex(e => e.id == establishment.id);
            state.user.space.establishments[index].prescription_logo_url = null;
        },
        EDIT_PRICING(state, active) {
            state.user.space.pricing = active;
        },
        ADD_MODULE(state, module) {
            state.user.modules.push(module.code);
            state.user.space.modules.push(module.code);
        },
        REMOVE_MODULE(state, module) {
            let index = state.user.modules.findIndex(m => m == module.code);
            state.user.modules.splice(index, 1);
            let index2 = state.user.space.modules.findIndex(m => m == module.code);
            state.user.space.modules.splice(index2, 1);
        },
        SET_EXTERNAL_ENTITY(state, external_entity) {
            state.user.space.external_entity = external_entity;
        },
        EDIT_NOTIFY_SMS(state, value) {
            state.user.space.notify_sms = value;
        },
        EDIT_NOTIFY_EMAIL(state, value) {
            state.user.space.notify_email = value;
        }
    },
    actions: {
        BEGIN_TOUR: ({commit}) => {
            commit('SET_TOUR_MODE', true)
        },
        END_TOUR: ({commit}) => {
            commit('SET_TOUR_MODE', false)
        },
        NEXT_STEP_TOUR: ({commit, getters}) => {
            commit('INCREMENT_TOUR_STEP', getters)
            return getters.tourStepEvent;
        },
        LOGIN: ({dispatch}, payload) => {
            return new Promise((resolve, reject) => {
                var link = '';
                const admin = payload['admin'];
                if (admin) link = '/admin';
                else link = '/login';
                axios.post(link, payload['form'])
                    .then(response => {
                        console.log(response)
                        if (response.status === 200) {
                            resolve(response.data);
                        }
                        if(!admin) dispatch('SET_ALERTS', response.data.alerts)
                    }).catch(error => {
                        reject(error);
                    })
            });
        },
        LOGOUT: () => {
            return new Promise((resolve, reject) => {
                axios.get('/logout')
                    .then(response => {
                        //commit('REMOVE_USER')
                        resolve(response.data);
                    }).catch(error => {
                        reject(error);
                    })
            });
        },
        REMOVE_USER: ({ commit }) => {
            commit('REMOVE_USER')
        },
        UPDATE_USER: ({ commit }, user) => {
            commit('SET_USER', user)
        },
        UPDATE_LANGUAGE: ({ commit }, lang) => {
            commit('SET_LANGUAGE', lang)
        },
        REGISTER: ({ commit }, payload) => {
            return new Promise((resolve, reject) => {
                console.log(commit)
                axios.post('/register', payload)
                    .then(response => {
                        console.log(response)
                        if (response.status === 200) {
                            resolve(response.data);
                        }
                    }).catch(error => {
                        reject(error);
                    })
            });
        },
        SET_TIMERS: ({ commit }, payload) => {
            commit('SET_TIMERS', payload)
        },
        SET_USER_MODULES: ({ commit }, modules) => {
            commit('SET_MODULES', modules)
        },
        SET_SPACE_SUBSCRIPTION_PLAN: ({ commit }, plan) => {
            commit('SET_SUBSCRIPTION_PLAN', plan)
        },
        ADD_TIMER_COMPLETE: ({ commit }) => {
            commit('ADD_TIMER_COMPLETE')
        },
        CLEAR_TIMER_NOTIFICATIONS: ({ commit }) => {
            axios.post('/api/timers/clear_notifications')
                .then(response => {
                    if (response.status === 200) {
                        commit('SET_TIMERS', response.data.timers);
                    }
                }).catch(error => {
                    console.log(error);
                })
        },
        SET_ALERTS: ({commit}, payload) => {
            commit('SET_ALERTS', payload)
        },
        HIDE_ALERTS: ({commit}) => {
            axios.post('/alerts/hide')
                .then(response => {
                    if (response.data == "OK") {
                        commit('REMOVE_ALERTS');
                    }
                }).catch(error => {
                    console.log(error);
                })
        },
        SET_GOOGLE_LOGGED: ({commit}, payload) => {
            commit('SET_GOOGLE_LOGGED', payload);
        },
        ADD_ESTABLISHMENT: ({commit}, payload) => {
            commit('ADD_ESTABLISHMENT', payload);
        },
        EDIT_ESTABLISHMENT: ({commit}, payload) => {
            commit('EDIT_ESTABLISHMENT', payload);
        },
        DELETE_ESTABLISHMENT: ({commit}, payload) => {
            commit('DELETE_ESTABLISHMENT', payload);
        },
        ADD_ESTABLISHMENT_OFFICE: ({commit}, payload) => {
            commit('ADD_ESTABLISHMENT_OFFICE', payload);
        },
        REMOVE_ESTABLISHMENT_OFFICE: ({commit}, payload) => {
            commit('REMOVE_ESTABLISHMENT_OFFICE', payload);
        },
        REMOVE_ESTABLISHMENT_LOGO: ({commit}, payload) => {
            commit('REMOVE_ESTABLISHMENT_LOGO', payload);
        },
        EDIT_PRICING: ({commit}, payload) => {
            commit('EDIT_PRICING', payload);
        },
        ADD_MODULE: ({commit}, payload) => {
            commit('ADD_MODULE', payload);
        },
        REMOVE_MODULE: ({commit}, payload) => {
            commit('REMOVE_MODULE', payload);
        },
        SET_EXTERNAL_ENTITY: ({commit}, payload) => {
            commit('SET_EXTERNAL_ENTITY', payload);
        },
        EDIT_NOTIFY_SMS: ({commit}, payload) => {
            commit('EDIT_NOTIFY_SMS', payload);
        },
        EDIT_NOTIFY_EMAIL: ({commit}, payload) => {
            commit('EDIT_NOTIFY_EMAIL', payload);
        }
    }
}